module.exports = "<div [ngClass]=\"(show) ? '': 'loader-hidden'\">\n  <div class=\"loader-overlay\">\n    <i [ngStyle]=\"{'font-size': loaderSize}\" class=\"fa fa-spinner fa-pulse\" id=\"loading-indicator\"></i>\n    <span class=\"sr-only\">Loading...</span>\n  </div>\n</div>\n\n<!-- <div style=\"position: relative; z-index: 10000; font-size: 32px\">\n  {{name}}\n</div> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/loader/loader.component.html
// module id = ./src/app/core/loader/loader.component.html
// module chunks = main